import React from 'react'
import {
  Switch,
  Route,
  Redirect,
} from 'react-router-dom'

import Login from '../Account/containers/Login'
import Register from '../Account/containers/Register'
import ForgotPassword from '../Account/containers/ForgotPassword'
import PrivateRoute from '../PrivateRoutes'
import PublicRoute from '../PublicRoutes'
import Profile from '../MyProfile/container'
import Orders from '../Orders/containers'
import Address from '../Address/containers'
import Wishlist from '../Wishlist/containers'


import { initPageView } from '../Analytics/common'

const GetRoutes = () => (
  <Switch>
    <Route exact path='/'>
      <Redirect to='/orders' />
    </Route>
    <PrivateRoute
      path='/wishlist'
      component={() => <Wishlist />}
    />
    <PrivateRoute
      path='/profile'
      component={() => <Profile />}
    />
    <PrivateRoute
      path='/address'
      component={() => <Address />}
    />
    <PrivateRoute
      path='/orders'
      component={() => <Orders />}
    />
    <PublicRoute
      path='/forgotpassword'
      component={() => {
        initPageView()
        return (
          <ForgotPassword
            footerLink={{
              text: 'Back to Sign in',
              link: '/signin',
            }}
          />
        )
      }}
    />
    <PublicRoute
      path='/signin'
      component={() => <Login />}
    />
    <PublicRoute
      path='/signup'
      component={() => <Register />}
    />
    <Route path='*'>
      <Redirect to='/orders' />
    </Route>
  </Switch>
)

export default GetRoutes

